<template>
  <router-link
    :class="`c-orange d-flex align-items-center shadow 
    border-radius bg-white p-1 no-text-decoration col-md-12 col-lg-7 col-xl-7 mt-2 mt-2`"
    :to="{ name: pushToRouteName }"
  >
    <b-badge class="bg-orange c-white fs-14 font-weight-lighter count-badge" v-if="!hideCountBadge">
      {{ count }}
    </b-badge>
    <div class="d-flex w-100 align-items-center px-2 justify-content-between">
      <span class="c-black fs-15">
        {{ itemText }}
      </span>
      <i v-if="!hideIcon" :class="`${icon} menu-icon fs-22 `" :style="iconStyle"></i>
    </div>
    <b-badge v-if="comingSoon" variant="warning" class="ml-2">Em breve</b-badge>
  </router-link>
</template>

<script>
export default {
  name: 'Item',
  props: {
    pushToRouteName: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      default: 0,
    },
    itemText: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    iconStyle: {
      type: String,
    },
    hideCountBadge: {
      type: Boolean,
      default: false,
    },
    comingSoon: {
      type: Boolean,
      default: false,
    },
    hideIcon: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.count-badge {
  min-width: 32px;
  min-height: 32px;
  max-width: 32px;
  max-height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.border-radius {
  border-radius: 8px;
}

.no-text-decoration:hover {
  color: var(--orange-primary);
  text-decoration: none;
}
</style>
